import React from "react";
import PropTypes from "prop-types";

const getIcon = (type) => {
  if (type === "pie") {
    return "fa fa-pie-chart";
  }
  if (type === "bar") {
    return "fa fa-bar-chart";
  }

  return "fa fa-bar-chart";
};

const EmptyStateChart = ({ name, type }) => (
  <div className="chart">
    <div className="custom-container">
      <div className="chart--empty">
        <i className={getIcon(type)} aria-hidden="true" />
        <p>
          No data available for <span className="emphasize">{name}</span>
        </p>
      </div>
    </div>
  </div>
);

EmptyStateChart.propTypes = {
  name: PropTypes.string,
  type: PropTypes.oneOf(["pie", "bar"]),
};

EmptyStateChart.defaultProps = { name: "this chart", type: "bar" };

export default EmptyStateChart;
